import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import HomeReducer from "./reducers/home";
import AuthReducer from "./reducers/auth";
import ProfileReducer from './reducers/profile';
import { thunk } from "redux-thunk";

// Remove redux dev tools in production mode
let composeEnhancers = compose;

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    composeEnhancers =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              trace: true,
              traceLimit: 25,
          }) 
        : compose;
}

const rootReducer = combineReducers({
    home: HomeReducer,
    auth: AuthReducer,
    profile: ProfileReducer,
});

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
);

export default store;
